import React, { useContext, useEffect, useState, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { AppContext } from '../AppContext';
import { GetUrlAndLogo } from '../services/OnbordingService';
import Loader from './Loader';
import footerTmobilePartner from "../image/footerTmobilePartner.png";

export default function Navbar() {
    const { responseMessage, setResponseMessage, setCurrentUrl, setCurrentStep } = useContext(AppContext);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const location = useLocation();
    const hasFetched = useRef(false);

    useEffect(() => {
        if (hasFetched.current) return;

        const initializeNavbar = async () => {
            try {
                setLoading(true);
                setError(null);

                // Fetch the config.json file
                const configResponse = await fetch('/config.json');
                const configData = await configResponse.json();

                // Set the default response data from config.json
                const updatedResponse = {
                    name: configData.name || 'Default Name',
                    logo_path: configData.logo_path || 'defaultLogo.png',  // fallback to default logo
                    code: configData.code || 'DefaultCode',  // fallback to default code
                };

                setResponseMessage(updatedResponse);
                //const baseApiUrl = "https://onboarding.nextgnation.com";
                //const baseApiUrl = "https://pcconboard.nextgnation.com";
                const baseApiUrl = window.location.origin;
                setCurrentUrl(window.location.origin);

                const payload = { url: baseApiUrl };
                const response = await GetUrlAndLogo(payload);

                if (response) {
                    const finalResponse = {
                        name: response.name && response.name !== "" ? response.name : updatedResponse.name, // Check for null, empty string
                        logo_path: response.logo_path && response.logo_path !== "" ? response.logo_path : updatedResponse.logo_path,
                        code: response.code && response.code !== "" ? response.code : updatedResponse.code,
                    };
                    setResponseMessage(finalResponse);
                }
            } catch (error) {
                // Handle errors here if needed
                console.error("Error loading config or API data:", error);
            } finally {
                setLoading(false);
            }
        };

        initializeNavbar();
        hasFetched.current = true;
    }, [setCurrentUrl, setResponseMessage]);

    const handleLogOut = () => {
        navigate("/");
    };

    const isApplicationPath =
        location.pathname === "/newApplicationPage" || location.pathname === "/applicationStatus";
    const logoPath = responseMessage?.logo_path;

    return (
        <>
            {loading ? (
                <Loader />
            ) : (
                <div>
                    <nav className="navbar navbar-expand-lg navbar-light sticky-top topBar">
                        <div className="container-fluid">
                            <a href="/" className="navbar-brand">
                                {logoPath && <img src={logoPath} alt="Logo" />}
                            </a>
                            <button
                                type="button"
                                className="navbar-toggler"
                                data-bs-toggle="collapse"
                                data-bs-target="#navbarCollapse"
                            >
                                <span className="navbar-toggler-icon"></span>
                            </button>

                            <div className="collapse navbar-collapse" id="navbarCollapse">
                                <div className="navbar-nav ms-auto">
                                    {isApplicationPath && (
                                        <a onClick={handleLogOut} className="btn btn-sm btn-primary logoutBtn">
                                            <i className="fa fa-user-circle-o"></i>&nbsp;&nbsp;LOGOUT
                                        </a>
                                    )}
                                    <a onClick={handleLogOut} className="footerTmobile">
                                        <img src={footerTmobilePartner} alt="T-Mobile" />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </nav>
                </div>
            )}
        </>
    );
}
